module.exports = __webpack_public_path__ + "img/影像医汇@2x.7ba6ee0f.png";